function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import { TYPES, SIZES } from '../../constants.js';
import Addon from '../common/Addon/Addon.js';
import { NumberInput } from '../common/Number';
import { TextInput } from '../common/TextInput';
import InputWrapper from '../InputWrapper.js';
const InputComponentMaps = {
  [TYPES.NUMBER]: NumberInput,
  [TYPES.TEXT]: TextInput
};

// eslint-disable-next-line react/display-name
const InputWithAddon = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    type = TYPES.TEXT,
    leftAddon = null,
    rightAddon = null,
    size = SIZES.MEDIUM,
    label = '',
    id = '',
    required = false,
    requiredLabel = '',
    isError = false,
    isSuccess = false,
    helpText = '',
    helpButtonData = null,
    name = '',
    disabled = false,
    validationText = '',
    style = {},
    readOnly = false,
    dataTestId = '',
    className = '',
    accessibleSuccessText = 'success',
    accessibleErrorText = 'error',
    step = 1,
    min = null,
    max = null,
    ...restProps
  } = props;
  const InputComponent = InputComponentMaps[type] ?? null;
  return /*#__PURE__*/React.createElement(InputWrapper, {
    label: label,
    id: id,
    required: required,
    requiredLabel: requiredLabel,
    isError: isError,
    isSuccess: isSuccess,
    helpText: helpText,
    helpButtonData: helpButtonData,
    validationText: validationText,
    style: style,
    className: className,
    accessibleErrorText: accessibleErrorText,
    accessibleSuccessText: accessibleSuccessText
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, leftAddon ? /*#__PURE__*/React.createElement(Addon, {
    isLeft: true,
    addOn: leftAddon,
    size: size,
    disabled: disabled || readOnly
  }) : null, InputComponent ? /*#__PURE__*/React.createElement(InputComponent, _extends({}, restProps, {
    ref: ref,
    name: name,
    dataTestId: dataTestId,
    type: type,
    size: size,
    required: required,
    isError: isError,
    isSuccess: isSuccess,
    leftAddon: leftAddon,
    rightAddon: rightAddon,
    id: id,
    disabled: disabled,
    label: label,
    helpText: helpText,
    readOnly: readOnly,
    validationText: validationText,
    step: step,
    min: min,
    max: max
  })) : null, rightAddon ? /*#__PURE__*/React.createElement(Addon, {
    isLeft: false,
    addOn: rightAddon,
    size: size,
    disabled: disabled || readOnly
  }) : null));
});
InputWithAddon.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPES)),
  leftAddon: PropTypes.object,
  rightAddon: PropTypes.object,
  size: PropTypes.oneOf(Object.values(SIZES)),
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  isError: PropTypes.bool,
  isSuccess: PropTypes.bool,
  helpText: PropTypes.string,
  helpButtonData: PropTypes.object,
  requiredLabel: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  validationText: PropTypes.string,
  readOnly: PropTypes.bool,
  style: PropTypes.object,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  accessibleErrorText: PropTypes.string,
  accessibleSuccessText: PropTypes.string,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number
};
export default /*#__PURE__*/memo(InputWithAddon);